import { CommentPropType } from "../../PropTypes";
import ContributionImage from "../ContributionImage/ContributionImage";
import { FormattedDateTime } from "../FormattedDateTime";
import CommentOptions from "../CommentOptions/CommentOptions";
import Avatar from "../Avatar/Avatar";
import "./pendingComment.scss";
import YouTubeVideo from "../YouTube/YouTube";
import { connect } from "react-redux";
import { selectors, dismissError } from "../../app/slices/itemSlice";
import React from "react";
import { selectors as mediaSelectors, setShowGallery, setGalleryIndex } from "../../app/slices/mediaSlice";
import LazyLoad from "../LazyLoad"; 
import PropTypes from "prop-types";
import { encodeProfileURL } from '../../helpers/urlHelper';
import { noListEntryFound
 } from "../../constants/errorMessages";
import { removeSpaces } from "../../helpers/utilities";

function PendingComment(props) {
  const { media, setShowGallery, setGalleryIndex, showGallery, profilePage } = props;
  const item = props.item ?? props.comment.item;

  /**
   * Generate url depending on whether or not the comment was made by an organisation user
   * @param {*} username 
   * @returns 
  */
  function generateUrl(username) {
    return props.comment.isCreatedByOrganisationUser ? encodeProfileURL(username) : encodeProfileURL(removeSpaces(username), props.comment.memberId); 
  }

  /** 
   * Get the item name or location
   * If the item name is "No name for this entry" and if the address is not empty show the address
   * Else show the item name
  */
  function getItemNameOrLocation() { 
    // check if the item location is null, if it is return the name
    if(item.location == null) {
      return item.name; 
    }
    return item.name.toLowerCase() === noListEntryFound.toLowerCase() && item.location.address !== "" ? item.location.address : item.name;
  }
 
  function handleImageClick(url) {
    if (Array.isArray(media)) {
      media.filter(({mediaTypeId}) => mediaTypeId !== 4).map((mediaItem, i) => {
        if (mediaItem.url === url) {
          setGalleryIndex(i);
        }
      })
    }
    setShowGallery(!showGallery);
  }

  const comments = [];
  if (props.comment.media && props.comment.media.length) {
    props.comment.media.forEach(() => comments.push(props.comment));
  }

  const captions = [];
  if (props.comment.media && props.comment.media.length) {
    props.comment.media.forEach((i) => captions.push(i.caption));
  }

  if (props.comment) {
    const commentPath = item.path != null ? new URL(item.path).pathname : "";

    return (
      <article className="ugc-comment ugc-pending-comment" itemProp="comment" itemScope itemType="http://schema.org/Comment">
        {
          !profilePage &&
          <CommentOptions
            profilePage={props.profilePage}
            comment={props.comment}
            item={item}
            pendingComment={true}
            dismissError={props.dismissError}
          />
        }
        {
          props.profilePage ?
            <span className="ugc-pening-comment__created-time">
              {FormattedDateTime(props.comment.created)}
            </span>
            :
            <div className="ugc-pending-comment__profile-section">
              <Avatar
                username={props.comment.username}
                src={props.comment.userAvatarUrl}/>

              <div className="ugc-pending-comment__profile-info">
                <p itemProp="author">
                  {props.comment.memberId !== "" && props.comment.username !== "Anonymous User" ? (
                    <a href={generateUrl(props.comment.username)}>
                      {props.comment.username}
                    </a>
                  ) : (
                    "Anonymous User"
                  )}
                </p>
                <time itemProp="commentTime" dateTime={props.comment.created}>{FormattedDateTime(props.comment.created)}</time>
              </div>
            </div>
        }


        <div className="ugc-comment__pending-message">
          <span className="icon icon--time-fill"/>
          <div>
            <span>Pending Approval</span>
            <span className="ugc-comment__pending-message-description"> - only visible to you until approved</span>
          </div>
        </div>

        {
          props.profilePage && (
            <p className="ugc-pending-comment__profile-page">
              Contributed to:&nbsp;
              <a href={`${window.location.origin}${commentPath}`}
                 aria-label="Go to pending comment">
                {item.implementation.name} ({getItemNameOrLocation()})
              </a>&nbsp;on <span>{FormattedDateTime(props.comment.created)}</span>
            </p>
          )}

        {
          props.comment.text &&
          <div itemProp="text">
            <p>
              {props.comment.text}
            </p>
          </div>
        }

        {
          props.comment.media?.length > 0 &&
          <div className="ugc-comment__gallery ugc-comment__gallery--pending">
            <div className="he-grid-row">
              {
                props.comment.media.map((media) =>
                  media.mediaTypeId === 4 ?
                    <div className="ugc-comment__gallery-item-wrapper he-grid-col-md-6">
                      <YouTubeVideo url={media.url}/>
                    </div>
                    :
                        <div className="ugc-comment__gallery-item-wrapper he-grid-col-md-6">
                            <LazyLoad>
                              {captions
                              .map((sourceIndex) => (
                                <figure key={sourceIndex}>
                                  <ContributionImage
                                    key={media.id}
                                    id={media.id}
                                    externalId={props.externalId}
                                    filename={media.filename}
                                    quality={80}
                                    starred={media.starred}
                                    description={media.description}
                                    caption={media.caption}
                                    itemIndex={sourceIndex}
                                    url={media.url}
                                    onClick={() => profilePage && handleImageClick(media.url)} 
                                  />
                              {media.caption}
                            </figure>
                          ))
                          .slice(0, 1)
                        }</LazyLoad>
                    </div>
                )
              }
            </div>
          </div>
        }

      </article>
    );
  } else {
    return null;
  }
}

PendingComment.propTypes = {
  comment: CommentPropType.isRequired,
  media: PropTypes.array,
};

const mapStateToProps = (state) => {
  return {
    media: mediaSelectors.media(state),
    showGallery: mediaSelectors.showGallery(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setShowGallery: (showGallery) => dispatch(setShowGallery(showGallery)),
    setGalleryIndex: (galleryIndex) => dispatch(setGalleryIndex(galleryIndex)),
    dismissError: () => dispatch(dismissError())
   };
};

export default connect(mapStateToProps, mapDispatchToProps)(PendingComment);
